import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Divider from 'fe-design-base/molecules/Divider';
import { Map as ImmutableMap } from 'immutable';

import DiscountField from 'features/biller/DiscountField/DiscountField';

import { centsToDollar } from 'util/formatter';

interface PriceSummaryProps {
  amountInCents: number;
  salesTaxInCents: number;
  companyId?: number;
  subscriptionType?: string;
  appliedDiscount?: ImmutableMap<any, any>;
  discountCode?: string;
  handleSetMaskedDiscountCode?: (code: string) => void;
  handleSetIsAmexCouponChecked?: (checked: boolean) => void;
  totalAmountInCents: number;
  selectedProductUuid?: string | null | undefined;
}

const PriceSummary = ({
  amountInCents,
  salesTaxInCents,
  companyId,
  subscriptionType,
  appliedDiscount,
  discountCode,
  handleSetMaskedDiscountCode,
  handleSetIsAmexCouponChecked,
  totalAmountInCents,
  selectedProductUuid,
}: PriceSummaryProps) => (
  <Box mt={32}>
    <Box>
      <Text variant="heading3" i18n="biller.purchase_method_module.summary" />
    </Box>
    <Box mt={24} gap={16} column>
      <Box row spacebetween>
        <Text
          variant="body"
          color="mono700"
          i18n="biller.purchase_method_module.base_fee"
        />

        <Text variant="body" color="mono900">
          ${centsToDollar(amountInCents)}
        </Text>
      </Box>

      {companyId &&
        subscriptionType &&
        handleSetMaskedDiscountCode &&
        handleSetIsAmexCouponChecked && (
          <Box mt={16}>
            <Box mb={8}>
              <Text
                variant="heading3"
                i18n="biller.purchase_method_module.discount"
              />
            </Box>
            <DiscountField
              forAdmin={false}
              companyId={companyId}
              billingCycle="monthly"
              subscriptionPlan={subscriptionType}
              appliedDiscount={appliedDiscount}
              maskedDiscountCode={discountCode}
              numberOfLocations={1}
              setMaskedDiscountCode={handleSetMaskedDiscountCode}
              discountAutoApplied={false}
              setIsAmexCouponChecked={handleSetIsAmexCouponChecked}
              subscriptionPriceNumeric={amountInCents / 100}
              selectedProductUuid={selectedProductUuid}
            />
          </Box>
        )}

      <Box row spacebetween>
        <Text
          variant="body"
          color="mono700"
          i18n="biller.purchase_method_module.sales_tax"
        />
        <Text variant="body" color="mono900">
          ${centsToDollar(salesTaxInCents)}
        </Text>
      </Box>
    </Box>
    <Box mt={24}>
      <Divider color="mono300" />
    </Box>
    <Box row spacebetween mt={24}>
      <Text
        variant="bodyBold"
        color="mono900"
        i18n="biller.purchase_method_module.total"
      />

      <Text variant="bodyBold" color="mono900">
        ${centsToDollar(totalAmountInCents)}
      </Text>
    </Box>
  </Box>
);

export default PriceSummary;
